import D1Table from './D1Table.component';

export default D1Table;
